import React from 'react';
import { FlaskConicalIcon, LeafIcon, ZapIcon, SmartphoneIcon, LockIcon } from 'lucide-react';
const items = [{
  icon: FlaskConicalIcon,
  label: 'Ciencia hormonal'
}, {
  icon: LeafIcon,
  label: '100% natural'
}, {
  icon: ZapIcon,
  label: 'Resultados en 7 días'
}, {
  icon: SmartphoneIcon,
  label: 'Acceso inmediato'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}];
export function TrustBar() {
  return <section className="bg-white py-6" data-id="element-216">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-217">
        <p className="text-xs text-gray-500 text-center mb-4 uppercase tracking-wide" data-id="element-218">
          MÉTODO BASADO EN CIENCIA HORMONAL
        </p>
        <div className="flex flex-wrap justify-center gap-8" data-id="element-219">
          {items.map((item, i) => <div key={i} className="flex flex-col items-center gap-2" data-id="element-220">
              <item.icon className="w-6 h-6 text-[#2D5A34]" data-id="element-221" />
              <span className="text-xs text-[#2D2D2D]" data-id="element-222">{item.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}